<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        Exchange Rate List
                    </div>
                    <div class="card-body">
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th v-for="(value, key) in columns" :key="key" @click="sortBy(key)" style="cursor:pointer">
                                            {{ value }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td>{{ data.currency.code }}</td>
                                        <td>{{ data.buyRate }}</td>
                                        <td>{{ data.sellRate }}</td>
                                        <td>{{ formatDate(data.updatedAt) }}</td>
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="Object.keys(columns).length" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import moment from 'moment'
    export default {
        name: 'exchangeRateList',
        metaInfo: {
            title: "Exchange Rate List",
            titleTemplate: "%s ← MIC",
        },
        components: {
            Loading
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                alert: "",
                dataList: [],
                permissions: '',
                date: '',
                columns: {
                    code: "Currency",
                    Buy: "Buy",
                    Sell: "Sell",
                    date: "Date"
                }
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
        computed: {},
        methods: {
            ...mapActions({
                getExchangeRate: 'getExchangeRate',
            }),
            async search() {
                this.filter.page = 1
                this.fetchData()
            },
            async fetchData() {
                this.isLoading = true
                let option = {}
                await this.getExchangeRate({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.latestRates
                        this.date = res.data.timestamp
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            },
            formatDate(date) {
                if (!date) return 'N/A';
                return moment(date).format('DD/MM/YYYY');
            }

        },
        mounted() {
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.permissions = user.permissions
            this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
   .badge-16 {
    font-size: 16px;
   }
</style>